import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as TipoCambioActions from "../../store/actions/tipoCambio.actions";
import { BannerHero } from "@components";
import { Productos } from "@components";
import { TipoCambio } from "@components";
import BarraIntermedia from "../BarraIntermedia/BarraIntermedia";
import Meta from "@components/Meta/Meta";
//import TilesBienesConvenios from "../TilesBienesConvenios/TilesBienesConvenios";
import { isEmpty } from "lodash";
import moment from "moment";
import "moment/locale/es";
import ResumeBanner from "../ResumeBanner/ResumeBanner";
import SegundaBarra from "../SegundaBarra/SegundaBarra";

moment.locale("es");

function HomeAhorroYCredito(props) {
  const dispatch = useDispatch();
  const [longDate, setLongDate] = useState("");

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { valores } = useSelector(({ Base }) => Base.TipoCambio);
  const { resumeBanner } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    dispatch(TipoCambioActions.getTipoCambio());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(valores)) {
      var dateData = valores[0]?.xfechA_TIPO_CAMBIO;
      var dateBase = moment(dateData).locale("es").format("dddd LL");
      var dateStr = dateBase.toString();
      var date = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
      setLongDate(date);
    }
  }, [valores]);

  const defRoute = rutas?.filter(
    (route) => route?.name === "HomeAhorroYCredito"
  );

  return (
    <>
      <Meta title={defRoute[0]?.title} description={defRoute[0]?.description} />
      <BannerHero />
      {!isEmpty(valores) && (
        <TipoCambio
          title={"TIPO DE CAMBIO DÓLAR: "}
          longDateStr={longDate}
          curSymbol="₡"
          compra={valores[0]?.xvaloR_COMPRA_INSTITUCION}
          venta={valores[0]?.xvaloR_VENTA_INSTITUCION}
          tasaBasicaPasiva={valores[0]?.xvaloR_COMPRA_OFICIAL}
        />
      )}
      <Productos />
      <BarraIntermedia />
      <ResumeBanner resumeItems={resumeBanner}/>
      <SegundaBarra/>
      {/*<TilesBienesConvenios/>*/}
      
    </>
  );
}

export default HomeAhorroYCredito;
